import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useCallback, useEffect, useState } from "react";
import AppButton from "../shares/AppButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import AppTimeLine from "../shares/AppTimeline";
import { OffreService } from "../../../service/OffreService";
import { showDateFR } from "../../../Helpers/utilsHelper";
import useToast from "../../../hooks/useToast";
import { InfoOutlined } from "@material-ui/icons";
import StandardSkeletoon from "../shares/loader/StandardSkeletoon";
import SortOutlinedIcon from "@mui/icons-material/SortOutlined";
import AppDropdownButton from "../shares/AppDropdownButton";

const OffreEmplois = () => {
  const [expandedGrids, setExpandedGrids] = useState([]);
  const [offresEmploies, setOffreEmplois] = useState([]);
  const [filteredRows, setfilteredRows] = useState([]);
  const [mesDemandes, setMesDemandes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtre, setFiltre] = useState({ mot_cle: "" });
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const { Toast, showToast } = useToast();
  const buttonTris = [
    {
      id: "1",
      name: "Par titre",
      path: "#",
      icon: "",
      loading: false,
      clickAction: () => {
        handleTri("libelle_type");
      },
    },
    {
      id: "2",
      name: "Le plus recents",
      path: "#",
      icon: "",
      loading: false,
      clickAction: () => {
        handleTri("date_debut_publication");
      },
    },
    {
      id: "3",
      name: "Par date de cloture",
      path: "#",
      icon: "",
      loading: false,
      clickAction: () => {
        handleTri("date_fin_publication");
      },
    },
  ];

  const handleTri = (triType) => {
    setfilteredRows(
      triType === "date_debut_publication"
        ? [...filteredRows].sort(
            (a, b) =>
              new Date(b.date_debut_publication) -
              new Date(a.date_debut_publication)
          )
        : triType === "date_fin_publication"
          ? [...filteredRows].sort(
              (a, b) =>
                new Date(b.date_fin_publication) -
                new Date(a.date_fin_publication)
            )
          : [...filteredRows].sort((a, b) => {
              const libelleCompare = a.libelle_type.localeCompare(
                b.libelle_type,
                "fr",
                {
                  sensitivity: "base",
                }
              );
              if (libelleCompare !== 0) {
                return libelleCompare; // d'abord tri par libelle asc
              }
              return a.description.localeCompare(b.description); // ensuite tri par description asc
            })
    );
  };

  const toggleExpandOffre = (idx) => {
    let ids = expandedGrids.slice();
    if (expandedGrids.includes(idx)) {
      const index = ids.indexOf(idx);
      if (index > -1) {
        ids.splice(index, 1);
      }
    } else {
      ids.push(idx);
    }
    setExpandedGrids(ids);
  };

  const handleFetchOffresList = () => {
    setLoading(true);
    OffreService.getAllOffre({})
      .then((res) => {
        if (res && res.data) {
          setOffreEmplois(res.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFilter = useCallback(
    (filterValue) => {
      setPage(1);
      if (!filterValue || String(filterValue).trim() === "") {
        setfilteredRows(offresEmploies);
        return;
      }
      const mots = filterValue
        .toLowerCase()
        .split(" ")
        .filter((mot) => mot.trim() !== "");
      setfilteredRows(
        offresEmploies.filter((item) =>
          mots.every((mot) =>
            Object.values(item).some(
              (val) => val && val.toString().toLowerCase().includes(mot)
            )
          )
        )
      );
    },
    [offresEmploies]
  );

  const handleFetchMesDemandes = (filtre) => {
    setLoading(true);
    OffreService.getAllOfMyDemands(filtre)
      .then((res) => {
        if (res && res.data) {
          setMesDemandes(res.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleFetchOffresList();
    handleFetchMesDemandes(null);
  }, []);

  useEffect(() => {
    handleFilter(filtre.mot_cle);
  }, [filtre.mot_cle, offresEmploies, handleFilter]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const count = Math.ceil(filteredRows.length / itemsPerPage);
  const paginatedRows = filteredRows.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const MAX_LINE = 3;
  return (
    <>
      <Toast />
      <Grid container display={"flex"} flexDirection={"row"} mr={2}>
        <Grid item md={9} xs={12}>
          <Grid container p={3} spacing={3}>
            <Grid item flexGrow={1}>
              <TextField
                id="reacherche"
                fullWidth
                size="small"
                onChange={(e) =>
                  setFiltre({ ...filtre, mot_cle: e.target.value })
                }
                placeholder="Recherche"
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            {/* <Grid item>
              <IconButton title="Trier">
                <SortOutlinedIcon />
              </IconButton>
            </Grid> */}
            <Grid item>
              <AppDropdownButton
                title={"Trier"}
                mainIcon={<SortOutlinedIcon />}
                ListButtons={buttonTris}
              />
            </Grid>
          </Grid>
          <CardHeader title="Liste des offres d'emploi" />
          <StandardSkeletoon show={loading} row={6} />
          <Grid display={loading ? "none" : "block"}>
            {paginatedRows.map((item, index) => (
              <Paper elevation={0} key={index}>
                <Grid item xs={12} m={1} key={`k-${index}`} minHeight={100}>
                  <CardHeader
                    title={item.libelle_type}
                    titleTypographyProps={{ variant: "h5" }}
                    subheader={
                      <>
                        {`Publié le: ${showDateFR(item.date_debut_publication)}`}
                        <Grid
                          mt={1}
                          sx={{ display: { xs: "flex", md: "none" } }}
                        >
                          <Chip
                            label={`Date de cloture: ${showDateFR(item.date_fin_publication)}`}
                            color="warning"
                            size="small"
                            variant="outlined"
                          />
                        </Grid>
                      </>
                    }
                    subheaderTypographyProps={{ variant: "caption" }}
                    action={
                      <Grid mt={1} sx={{ display: { xs: "none", md: "flex" } }}>
                        <Chip
                          label={`Date de cloture: ${showDateFR(item.date_fin_publication)}`}
                          color="warning"
                          size="small"
                          variant="outlined"
                        />
                      </Grid>
                    }
                  />
                  <CardContent>
                    <Grid>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        textAlign={"justify"}
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: expandedGrids.includes(index)
                            ? "unset"
                            : MAX_LINE,
                        }}
                        component={"div"}
                      >
                        {item.description}
                        <br />
                        <Grid container spacing={1} mt={1}>
                          <Grid item>
                            <Chip
                              sx={{ mb: 2, mt: 2 }}
                              variant="outlined"
                              label={`Type : ${item.type}`}
                            />
                          </Grid>
                          <Grid item>
                            <Chip
                              sx={{ mb: 2, mt: 2 }}
                              variant="outlined"
                              label={`${item.desc}`}
                            />
                          </Grid>
                        </Grid>
                        <br />
                      </Typography>
                    </Grid>
                  </CardContent>
                  <CardActions
                    sx={
                      {
                        /* justifyContent: "flex-end" */
                      }
                    }
                  >
                    <AppButton
                      size="small"
                      variant="contained"
                      component={Link}
                      to={
                        // item.desc === "Volontariat"
                        //   ? `/mon-profile?tab=1&job_id=${item.id_type}&action=soummetre demande`:
                        `/offre-emploi/postule?job_id=${item.id_type}`
                      }
                      text={"Postuler"}
                    />
                    <AppButton
                      size="small"
                      style={{
                        textTransform: "initial",
                        display:
                          MAX_LINE < item.description.split("\n").length
                            ? "block"
                            : "none",
                      }}
                      onClick={() => toggleExpandOffre(index)}
                      text={
                        expandedGrids.includes(index)
                          ? "Voir moins"
                          : "Voir plus"
                      }
                    />
                  </CardActions>
                </Grid>
                <Divider variant="middle" flexItem sx={{ m: 1 }} />
              </Paper>
            ))}
            {count > 1 && (
              <Stack spacing={2} mt={5} alignItems="center">
                <Pagination
                  count={count}
                  page={page}
                  onChange={handlePageChange}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                />
              </Stack>
            )}
          </Grid>
          <Grid display={loading ? "none" : "block"}>
            {offresEmploies.length > 0 && filteredRows.length === 0 && (
              <Grid m={2}>
                <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                  Aucune offre ne correspond à votre recherche.
                </Alert>
              </Grid>
            )}
            {offresEmploies.length === 0 && !loading && (
              <Grid m={2}>
                <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                  Aucune information trouvée
                </Alert>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ m: 2 }} />
        <Grid
          item
          sx={{
            display: "none",
            // mesDemandes.length === 0 ? "none" : { xs: "none", md: "block" },
          }}
          md={2.5}
          flexGrow={1}
        >
          <CardHeader
            title="Statut de mes demandes"
            titleTypographyProps={{ variant: "h6" }}
          />
          {mesDemandes.map((item, index) => (
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <h4>{item.titre}</h4>
              </AccordionSummary>
              <Divider />
              <AccordionDetails>
                <Grid>
                  <AppTimeLine id_offre={item.id_offre} />
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))}
          <Grid mt={2}>
            <AppButton
              to={"/mes-demandes"}
              component={Link}
              style={{
                textTransform: "capitalize",
                display: mesDemandes.length === 0 ? "none" : "block",
              }}
              text={"Afficher tous"}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default OffreEmplois;
